import React from 'react';
import ModalMessage from './ModalMessage';

export default (props) => <ModalMessage status={'warning'} {...props} />;
